/** Approved product identity: S3T. Use ASCII S3T for text and URL contexts. */
export const streamerBrand = {
  name: 'S3T',
  fullName: 'Shadow & Shout Streamer Tools',
  descriptor: 'Source studio',
} as const
